import NavBack from "./nav-back";
import NavCancel from "./nav-cancel";
import { useRouterContext } from "../contexts";
import { $$, changeHash } from "../utils/dom";

interface BackButtonProps {
  setLoginOpen?: (open: boolean) => void;
  close?: boolean;
}

const BackButton = ({
  setLoginOpen = () => {},
  close = false,
}: BackButtonProps) => {
  // const {
  //   removeProduct,
  //   state: { productDetail },
  // } = useContext(AppContext);
  const { asPath, replace } = useRouterContext();

  const goBack = () => {

    // Handle account detail pages specifically
    // For sales/[id] -> go to /account/sales
    if (asPath.match(/^\/account\/sales\/[\w-]+/)) {
      replace("/account/sales");
      return;
    }

    // For purchases/[id] -> go to /account/purchases
    if (asPath.match(/^\/account\/purchases\/[\w-]+/)) {
      replace("/account/purchases");
      return;
    }

    // For other account subpages -> go to /account
    if (asPath.match(/^\/account\/[^\/]+$/)) {
      replace("/account/");
      return;
    }

    // For main account page -> go to home
    if (asPath === "/account" || asPath === "/account/") {
      replace("/");
      return;
    }

    // Default behavior for non-account pages (a click, so always in the browser)
    window.history.back();
  };

  // if (
  //   (history && history.length < 2) ||
  //   (router.asPath === "/" && !router.asPath.includes("account"))
  // )
  //   return;

  return (
    <div
      className="nav-exit"
      data-testid="header-back-btn"
      onClick={() => {
        const sp = $$(".s2nPlayerContainer")[0];
        if (sp) sp.style.display = "block";
        if (close) {
          setLoginOpen(false);
          changeHash("")
        } else {
          goBack();
        }
      }}
    >
      {close ? <NavCancel /> : <NavBack />}
    </div>
  );
};

export default BackButton;
